var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{class:_vm.value == null ? 'text-secondary' : 'text-primary',attrs:{"options":_vm.weekdays},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }